(function(){
  function initOGCAnalytics(root){
    if(!root || root.dataset.ogcAnalyticsInit==='true') return;
    root.dataset.ogcAnalyticsInit='true';

  // Scroll reveal + comparison animation
  (function () {
    var els = root.querySelectorAll('[data-reveal], .cmp-r-ogc');

    if (!('IntersectionObserver' in window)) { 
      els.forEach(function(el){ 
        el.classList.add('is-visible'); 
      }); 
      return; 
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var el = entry.target;

        // stagger comparison rows
        if (el.classList.contains('cmp-r-ogc')) {
          var rows = Array.prototype.slice.call(
            root.querySelectorAll('.cmp-r-ogc')
          );

          var index = rows.indexOf(el);

          var check = el.querySelector('.cmp-mark-check');
          var text = el.querySelector('p');

          if (check) {
            check.style.animationDelay = (index * 120) + 'ms';
          }

          if (text) {
            text.style.animationDelay = (index * 120 + 120) + 'ms';
          }
        }

        el.classList.add('is-visible');
        io.unobserve(el);
      });
    }, { 
      threshold: 0.15, 
      rootMargin: '0px 0px -40px 0px' 
    });

    els.forEach(function (el) { 
      io.observe(el); 
    });
  })();

  // Interactive hero chart — Profile Views & Contact Saves across the month
  (function () {
    var chart = root.querySelector('#acChart');
    if (!chart) return;
    var plot = chart.querySelector('.ac-plot');

    // Day-by-day series for the month — weekly rhythm (weekend dips) on a rising trend.
    var views = [48,55,62,66,60,52,58,68,76,82,86,80,70,75,88,96,102,106,98,88,94,108,116,122,126,118,108,114,128,138];
    var saves = [14,17,20,22,18,15,18,21,24,27,29,25,21,24,28,31,34,36,31,27,30,34,37,40,42,37,33,36,40,46];
    var N = views.length;

    var MONTH = 'Jul';
    var SVGNS = 'http://www.w3.org/2000/svg';

    // ViewBox covers the PLOT ONLY. Axis labels are HTML overlays (constant CSS
    // font, positioned geometrically) so nothing scales/misaligns on mobile.
    var VBW = 760, VBH = 330;
    var padL = 8, padR = 8, padT = 12, padB = 12;   // small insets so strokes/dots don't clip
    var innerW = VBW - padL - padR;
    var innerH = VBH - padT - padB;
    var maxY = 150;                 // nice round ceiling above the peak (138)
    var yTicks = [0, 30, 60, 90, 120, 150];

    function xAt(i) { return padL + innerW * (i / (N - 1)); }
    function yAt(v) { return padT + innerH * (1 - v / maxY); }

    // Smooth path via Catmull-Rom → cubic bezier (clamped so it never dips below 0)
    function smoothPath(vals) {
      var p = vals.map(function (v, i) { return [xAt(i), yAt(v)]; });
      var d = 'M' + p[0][0] + ',' + p[0][1];
      for (var i = 0; i < p.length - 1; i++) {
        var p0 = p[i - 1] || p[i];
        var p1 = p[i];
        var p2 = p[i + 1];
        var p3 = p[i + 2] || p2;
        var c1x = p1[0] + (p2[0] - p0[0]) / 6;
        var c1y = p1[1] + (p2[1] - p0[1]) / 6;
        var c2x = p2[0] - (p3[0] - p1[0]) / 6;
        var c2y = p2[1] - (p3[1] - p1[1]) / 6;
        d += 'C' + c1x + ',' + c1y + ' ' + c2x + ',' + c2y + ' ' + p2[0] + ',' + p2[1];
      }
      return d;
    }

    function el(name, attrs) {
      var n = document.createElementNS(SVGNS, name);
      for (var k in attrs) n.setAttribute(k, attrs[k]);
      return n;
    }

    var svg = el('svg', { class: 'ac-svg', viewBox: '0 0 ' + VBW + ' ' + VBH, preserveAspectRatio: 'none' });

    // Gridlines (labels are HTML overlays, added below)
    yTicks.forEach(function (t) {
      var y = yAt(t);
      svg.appendChild(el('line', { class: 'ac-grid', x1: 0, y1: y, x2: VBW, y2: y }));
    });

    // Light blue vertical gradient for the area — darkest under the views line
    // (top), fading to near-white at the axis (bottom).
    var defs = el('defs', {});
    var grad = el('linearGradient', { id: 'acAreaGrad', x1: 0, y1: 0, x2: 0, y2: 1 });
    grad.appendChild(el('stop', { offset: '0%',   'stop-color': '#005AD1', 'stop-opacity': '0.28' }));
    grad.appendChild(el('stop', { offset: '55%',  'stop-color': '#005AD1', 'stop-opacity': '0.06' }));
    grad.appendChild(el('stop', { offset: '100%', 'stop-color': '#005AD1', 'stop-opacity': '0' }));
    defs.appendChild(grad);
    // Clip for the area so its reveal can sweep left→right in sync with the line draw.
    var areaClip = el('clipPath', { id: 'acAreaClip' });
    var clipRect = el('rect', { x: 0, y: 0, width: VBW, height: VBH });
    areaClip.appendChild(clipRect);
    defs.appendChild(areaClip);
    svg.appendChild(defs);

    // Area under the views line
    var areaD = smoothPath(views) + 'L' + xAt(N - 1) + ',' + yAt(0) + 'L' + xAt(0) + ',' + yAt(0) + 'Z';
    var areaPath = el('path', { class: 'ac-area ac-area-views', d: areaD, 'clip-path': 'url(#acAreaClip)' });
    svg.appendChild(areaPath);

    // Lines
    var lineS = el('path', { class: 'ac-line ac-line-saves', d: smoothPath(saves) });
    var lineV = el('path', { class: 'ac-line ac-line-views', d: smoothPath(views) });
    svg.appendChild(lineS);
    svg.appendChild(lineV);

    // Hover guide + highlight dots
    var guide = el('line', { class: 'ac-guide', x1: 0, y1: padT, x2: 0, y2: VBH - padB });
    svg.appendChild(guide);
    var dotV = el('g', { class: 'ac-dot ac-dot-views' }); dotV.appendChild(el('circle', { r: 5 })); svg.appendChild(dotV);
    var dotS = el('g', { class: 'ac-dot ac-dot-saves' }); dotS.appendChild(el('circle', { r: 5 })); svg.appendChild(dotS);

    plot.appendChild(svg);

    // ── HTML overlay axis labels (constant CSS font, positioned geometrically) ──
    // Y-axis labels, vertically centered on each gridline.
    var yAxis = document.createElement('div'); yAxis.className = 'ac-yaxis';
    yTicks.forEach(function (t) {
      var l = document.createElement('div');
      l.className = 'ac-ylabel';
      l.style.top = (yAt(t) / VBH * 100) + '%';
      l.textContent = t;
      yAxis.appendChild(l);
    });
    plot.appendChild(yAxis);

    // Tooltip
    var tip = document.createElement('div');
    tip.className = 'ac-tip';
    plot.appendChild(tip);

    var xs = []; for (var i = 0; i < N; i++) xs.push(xAt(i));

    function show(i) {
      chart.classList.add('is-active');
      guide.setAttribute('x1', xs[i]); guide.setAttribute('x2', xs[i]);
      dotV.firstChild.setAttribute('cx', xs[i]); dotV.firstChild.setAttribute('cy', yAt(views[i]));
      dotS.firstChild.setAttribute('cx', xs[i]); dotS.firstChild.setAttribute('cy', yAt(saves[i]));
      tip.innerHTML =
        '<div class="ac-tip-date">' + MONTH + ' ' + (i + 1) + '</div>' +
        '<div class="ac-tip-row"><span class="ac-tip-dot ac-tip-dot-views"></span>' +
          '<span class="ac-tip-label">Profile Views</span><span class="ac-tip-val">' + views[i] + '</span></div>' +
        '<div class="ac-tip-row"><span class="ac-tip-dot ac-tip-dot-saves"></span>' +
          '<span class="ac-tip-label">Contact Saves</span><span class="ac-tip-val">' + saves[i] + '</span></div>';
      // Position over the SVG (inset by the y-axis gutter), clamped to it.
      // NB: <svg> has no offsetLeft/clientWidth, so measure via bounding rects.
      var prect = plot.getBoundingClientRect(), srect = svg.getBoundingClientRect();
      var sx = srect.left - prect.left, sy = srect.top - prect.top;
      var sw = srect.width, sh = srect.height;
      var px = sx + (xs[i] / VBW) * sw;
      var half = tip.offsetWidth / 2;
      tip.style.left = Math.max(sx + half + 2, Math.min(sx + sw - half - 2, px)) + 'px';
      tip.style.top = (sy + (yAt(Math.max(views[i], saves[i])) / VBH) * sh) + 'px';
    }
    function hide() { chart.classList.remove('is-active'); }

    function nearest(clientX) {
      var rect = svg.getBoundingClientRect();
      var vx = ((clientX - rect.left) / rect.width) * VBW;
      var best = 0, bd = Infinity;
      for (var i = 0; i < N; i++) { var d = Math.abs(xs[i] - vx); if (d < bd) { bd = d; best = i; } }
      return best;
    }

    svg.addEventListener('pointermove', function (e) { show(nearest(e.clientX)); });
    svg.addEventListener('pointerdown', function (e) { show(nearest(e.clientX)); });
    svg.addEventListener('pointerleave', hide);

    // Re-anchor the resting tooltip when the chart resizes.
    function reflow() {
      if (chart.classList.contains('is-active')) show(N - 1);
    }
    if (window.ResizeObserver) { new ResizeObserver(reflow).observe(plot); }
    else { window.addEventListener('resize', reflow); }

    // ── On-load animation: lines draw in left→right, area fades up after ──
    var restingTip = window.matchMedia && window.matchMedia('(min-width: 560px) and (pointer: fine)').matches;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      if (restingTip) show(N - 1);
    } else {
      [lineV, lineS].forEach(function (p) {
        var len = p.getTotalLength();
        p.style.strokeDasharray = len;
        p.style.strokeDashoffset = len;
      });
      clipRect.style.width = '0px';

      requestAnimationFrame(function () { requestAnimationFrame(function () {
        lineV.style.transition = 'stroke-dashoffset 2s cubic-bezier(.4,0,.2,1)';
        lineS.style.transition = 'stroke-dashoffset 2s cubic-bezier(.4,0,.2,1) .35s';
        lineV.style.strokeDashoffset = 0;
        lineS.style.strokeDashoffset = 0;
        // Area sweeps left→right with the same duration/easing as the line draw.
        clipRect.style.transition = 'width 2s cubic-bezier(.4,0,.2,1)';
        clipRect.style.width = VBW + 'px';
      }); });

      // Once drawn, clear the dash props (so hover/resize can't leave gaps)
      // and reveal the resting tooltip.
      setTimeout(function () {
        [lineV, lineS].forEach(function (p) {
          p.style.transition = '';
          p.style.strokeDasharray = '';
          p.style.strokeDashoffset = '';
        });
        clipRect.style.transition = '';
        clipRect.style.width = '';
        if (restingTip && !chart.classList.contains('is-active')) show(N - 1);
      }, 2550);
    }
  })();

  // Pipeline Overview — hover card showing stage name + deal count
  (function () {
    var radial = root.querySelector('.cm-radial');
    if (!radial) return;
    var tip = radial.querySelector('.cm-radial-tip');
    var name = tip.querySelector('.cm-rt-name');
    var deals = tip.querySelector('.cm-rt-deals');
    function place(e) {
      var r = radial.getBoundingClientRect();
      tip.style.left = (e.clientX - r.left) + 'px';
      tip.style.top = (e.clientY - r.top) + 'px';
    }
    radial.querySelectorAll('.cm-ring-hit').forEach(function (h) {
      h.addEventListener('pointerenter', function () {
        name.textContent = h.getAttribute('data-stage');
        deals.textContent = h.getAttribute('data-deals') + ' deals';
        tip.classList.add('on');
      });
      h.addEventListener('pointermove', place);
      h.addEventListener('pointerleave', function () { tip.classList.remove('on'); });
    });
  })();


    if(window.lucide){ window.lucide.createIcons({attrs:{'aria-hidden':'true'}}); }
  }
  function boot(){ document.querySelectorAll('[data-ogc-analytics-page]').forEach(initOGCAnalytics); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
